export default __webpack_public_path__ + "static/media/revenue.9cb65f1b.svg";